<template>

  <Form
    :title="$t('Diversity')"
    :creating="creating"
    :loading="loading">
    <form
      id="profile-form"
      class="shurt-conatiner"
      v-on:submit.prevent="saveProfile(settings)">
      
      <div class="alert alert-secondary">
        <div class="form-group m-0">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="gdpr"
              v-model="settings.diversity">
            <label
              class="form-check-label"
              for="gdpr">
              Habilitar DE&I (Diversidade, Equidade e Inclusão)
              </label>
          </div>
          <ValidateMessage :error="validateErrors['settings.diversity']" />
          <div class="text-muted">Exibir recursos e configurações para relacionados a Diversidade, Equidade e Inclusão.</div>
        </div>
      </div>

      <div v-if="settings.diversity">
        <h5 class="my-4">Questões de diversidade no formulário de candidatura</h5>
        <div class="text-muted mb-3">(Automático) Adiciona ao formulário de candidatura questões relacioadas a diversidade.</div>

        <div class="form-group">
          <label class="control-label">{{ $t('Countries') }}</label>
          <select-country
            multiple
            v-model="settings.diversity_countries"
            :placeholder="$t('All countries')">
            </select-country>
          <ValidateMessage :error="validateErrors.diversity_countries" />
        </div>

        <h5 class="my-4">Solicitação de informações</h5>
        <p>Para os candidatos que não se aplicaram na página de carreiras, você poderá enviar uma mensagem solicitando informações adicionais relacionadas a DE&I.</p>
        <div>
          <label>Mensagem de solicitação</label>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              :placeholder="$t('Subject')"
              v-model="settings.diversity_email_subject">
            <ValidateMessage :error="validateErrors['settings.diversity_email_subject']" />
          </div>
          <div class="form-group">
            <textarea-editable
              editor-model="html"
              :enable-link="true"
              :enable-img="true"
              :maxHeight="280"
              v-model="settings.diversity_email_body">
              </textarea-editable>
            <ValidateMessage :error="validateErrors['settings.diversity_email_body']" />
          </div>
        </div>
      </div>
      
    </form>
    <template slot="actions">
      <button
        :class="{'box-loading': loading}"
        type="submit"
        form="profile-form"
        class="btn btn-primary">
        {{ $t('Save') }}
        </button>
    </template>
  </Form>

</template>

<script>
import Form from '@/components/Form/Form'
import InputOnePhoto from '@/components/Fields/InputOnePhoto'
import SelectCountry from '@/components/Fields/SelectCountry'

export default {
  name: 'AccountProfile',
  components: {
    Form,
    InputOnePhoto,
    SelectCountry
  },
  data () {
    return {
      creating: true,
      loading: false,
      settings: {},
      validateErrors: false
    }
  },
  computed: {
    account () {
      return this.$store.getters.getAccount
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.$store
      .dispatch('getAccountSettings', this.account._id)
      .then(result => {
        this.settings = result.settings
        this.creating = false
      })
    },
    /*
    saveProfile
    */
    saveProfile (data) {
      this.loading = true

      this.$store
      .dispatch('updateAccountSettings', {
        _id: this.account._id,
        settings: data
      })
      .then((result) => {
        this.settings = result.settings
        this.loading = false
        this.validateErrors = {}
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Account/AccountDiversity.vue